<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>
  @let formGroup = $formGroup();
  <unity-card-new-shared
    actionName="Send Registration to User"
    [formGroup]="formGroup"
    [formLoading]="$formLoading()"
    (submitEvent)="onSubmit()">
    <unity-dropdown-agency-control
      displayName="Business Partner"
      description="Select the business partner for which the new user is working."
      filter="external"
      [control]="formGroup.controls.agency_id"
      (selectionChangeEvent)="onAgencySelect($event)" />
    <unity-textbox-control
      displayName="Email Address"
      description="Enter the email address of the new user. They will receive a registration email once you submit this form."
      [control]="formGroup.controls.user_name" />
    <unity-textbox-control
      displayName="First Name"
      description="Enter the new user's first name (given name)."
      [control]="formGroup.controls.first_name" />
    <unity-textbox-control
      displayName="Last Name"
      description="Enter the new user's last name (surname or family name)."
      [control]="formGroup.controls.last_name" />
    @let selectedAgencyId = $selectedAgencyId();
    @if (selectedAgencyId) {
      <unity-dropdown-control
        displayName="Role"
        description="Select the new user's role at this agency."
        [control]="formGroup.controls.role_id"
        [values]="$inputRoles()?.data ?? []" />
    }
  </unity-card-new-shared>
</unity-page-container>
